import React from 'react'
import ReleaseBadge from './ReleaseBadge'

export * from './ReleaseBadge'
export default React.memo(ReleaseBadge)
